import { IconProps } from "../icon.types"

type Props = IconProps

export const IconAssembling = ({ size = 24, ...props }: Props) => (
  <svg
    id="assembling_svg__Calque_1"
    xmlns="http://www.w3.org/2000/svg"
    x={0}
    y={0}
    viewBox="0 0 44 44"
    xmlSpace="preserve"
    width={size}
    height={size}
    {...props}
  >
    <style>
      {
        ".assembling_svg__st0{fill:none;stroke:currentColor;stroke-width:2}.assembling_svg__st1{fill:currentColor}"
      }
    </style>
    <path
      className="assembling_svg__st0"
      d="M38.6 35.2v-3l-33-.3c0 2.2 6.4 3.5 11 3.5h21.7c.2 0 .3-.1.3-.2z"
    />
    <path
      className="assembling_svg__st1"
      d="M23.5 30c.2.2.6.2.8 0l3.7-3.7c.2-.2.2-.6 0-.8-.2-.2-.6-.2-.8 0l-3.3 3.3-3.3-3.3c-.2-.2-.6-.2-.8 0-.2.2-.2.6 0 .8l3.7 3.7zm1-5.8c0-.3-.3-.6-.6-.6s-.6.3-.6.6h1.2zm0 5.3v-5.3h-1.2v5.3h1.2z"
    />
    <path
      className="assembling_svg__st0"
      d="M38.6 14.8c-4.6 0-7.3 4.4-7.3 6.8"
    />
    <path
      className="assembling_svg__st0"
      d="M36.8 21.4c1.1 0 1.8-.9 1.8-1.6v-8.4c0-.7-.6-1.3-1.3-1.3h-.8c-.3 0-.6.2-.6.6V12c0 1.5-5.4.8-6.9.8-.8-.8-1.5-2-2.6-3.1-.1-.1-.2-.1-.3-.1-4.8.4-10.5 5.7-16.4 6.2-.1 0-4 .4-4 3.6-.1 3.8 30 2 31.1 2z"
    />
    <path
      className="assembling_svg__st1"
      d="M22.7 14.2c.3.6 1.1.7 1.6.4.6-.3.7-1.1.4-1.6l-2 1.2zM21 11.5l1.7 2.7 2-1.2-1.7-2.8-2 1.3zM20.1 15.4c.3.6 1.1.7 1.6.4.6-.3.7-1.1.4-1.6l-2 1.2zm-1.7-2.8 1.7 2.7 2-1.2-1.7-2.7-2 1.2zM17.5 16.2c.3.6 1 .8 1.6.4.6-.3.8-1 .4-1.6l-2 1.2zm-1.4-2.5 1.4 2.5 2-1.2-1.4-2.5-2 1.2z"
    />
  </svg>
)
